<button
  class="scroll-button"
  [disabled]="disabled"
  [ngClass]="{ 'scroll-button--disabled': disabled }"
  (click)="scroll()"
>
  <ng-container *ngIf="icon">
    <img
      class="scroll-button__icon"
      alt="scroll-button icon"
      mfpLazyImage
      [lazySrc]="icon"
      [ngClass]="{ 'scroll-button__icon--no-margin': !label }"
    >
  </ng-container>
  <span>{{ label }}</span>
</button>
